import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUrunMaliyetAnalizi_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUrunMaliyetAnalizi_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetItemInventoryTotal: any[];
  GetItemInventoryTotal_dummy: any[];
  GetItemInventoryCollectionChar: any[];
  GetItemInventoryCollectionChar_dummy: any[];
  GetItemInventoryWareHouseChar: any[];
  GetItemInventoryWareHouseChar_dummy: any[];
  GetItemInventoryGrid: any[];
  GetItemInventoryGrid_dummy: any[];
  ListUser: any[];
  ListUser_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class UrunMaliyetAnalizi_ScreenBase extends React.PureComponent<
  IUrunMaliyetAnalizi_ScreenProps,
  any
> {
  urunmaliyetanalizi_38920_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "bd3a0822-01aa-44f5-9ded-c1a8d688ffa6",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 19075, PropertyName: "label", Value: "Profil" },
        { Id: 98105, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 321259, PropertyName: "value", Value: "Ürün Envanter Analizi" },
        { Id: 554173, PropertyName: "value", Value: "Envanter Miktarı" },
        { Id: 263376, PropertyName: "value", Value: "adet" },
        { Id: 653069, PropertyName: "value", Value: "metrekare" },
        { Id: 840941, PropertyName: "value", Value: "Maliyet Tutarı" },
        { Id: 131904, PropertyName: "value", Value: "Top 5 Koleksiyon" },
        { Id: 622157, PropertyName: "value", Value: "Mağaza/Depo Bazında" },
        { Id: 904302, PropertyName: "value", Value: "Ürün Ara" },
        { Id: 636739, PropertyName: "placeholder", Value: "Ürün ara..." },
        { Id: 178454, PropertyName: "label", Value: "Ara" },
        { Id: 530330, PropertyName: "label", Value: "Temizle" },
        {
          Id: 38920,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 97762, PropertyName: "title", Value: "Title" },
        { Id: 657610, PropertyName: "value", Value: "Ürün adı" },
        {
          Id: 733260,
          PropertyName: "value",
          Value: "[datafield:productdescription]",
        },
        { Id: 3684, PropertyName: "value", Value: "Adet" },
        {
          Id: 937904,
          PropertyName: "value",
          Value: "[datafield:inventoryqty1]",
        },
        { Id: 746267, PropertyName: "value", Value: "Mr2" },
        {
          Id: 417635,
          PropertyName: "value",
          Value: "[datafield:inventoryqty2]",
        },
        { Id: 732118, PropertyName: "value", Value: "Maliyet Tutarı" },
        {
          Id: 712169,
          PropertyName: "value",
          Value: "[datafield:inventoryqty2]",
        },
        { Id: 981268, PropertyName: "value", Value: "Birrim" },
        {
          Id: 2826,
          PropertyName: "value",
          Value: "[datafield:unitofmeasurecode1]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.urunmaliyetanalizi_636739_value_kuikaTextInputRef = React.createRef();
    this.urunmaliyetanalizi_38920_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetItemInventoryTotal: [],
      GetItemInventoryCollectionChar: [],
      GetItemInventoryWareHouseChar: [],
      GetItemInventoryGrid: [],
      ListUser: [],
      GetImage: [],
      SetValueOf: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("urunmaliyetanalizi", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UrunMaliyetAnaliziPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("urunmaliyetanalizi", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("urunmaliyetanalizi", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UrunMaliyetAnaliziPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UrunMaliyetAnaliziPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ItemDescription_3: ReactSystemFunctions.convertToTypeByName("", "string"),
      ProductAtt03Desc_3: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt05Desc_3: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt07Desc_3: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      Filter_3: ReactSystemFunctions.convertToTypeByName(0, "number"),
      kUserId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.ListUser !== undefined
            ? stateVars.ListUser?.length > 0
              ? stateVars.ListUser[0].id
              : null
            : this.state.ListUser?.length > 0
            ? this.state.ListUser[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunMaliyetAnalizi/UrunMaliyetAnaliziPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryTotal = result?.data.getItemInventoryTotal;
    formVars.urunmaliyetanalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty1
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty1
        : null
    );
    formVars.urunmaliyetanalizi_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty2
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty2
        : null
    );
    formVars.urunmaliyetanalizi_423700_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty2
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty2
        : null
    );
    stateVars.GetItemInventoryCollectionChar =
      result?.data.getItemInventoryCollectionChar;

    stateVars.GetItemInventoryWareHouseChar =
      result?.data.getItemInventoryWareHouseChar;

    stateVars.GetItemInventoryGrid = result?.data.getItemInventoryGrid;

    stateVars.ListUser = result?.data.listUser;
    stateVars.GetImage = result?.data.getImage;
    formVars.urunmaliyetanalizi_299396_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UrunMaliyetAnaliziPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunMaliyetAnaliziPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.urunmaliyetanalizi_299396_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.urunmaliyetanalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty1
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty1
        : null
    );

    formVars.urunmaliyetanalizi_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty2
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty2
        : null
    );

    formVars.urunmaliyetanalizi_423700_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty2
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty2
        : null
    );

    stateVars.dataSource_605562 =
      stateVars.GetItemInventoryCollectionChar ??
      this.state.GetItemInventoryCollectionChar;

    stateVars.dataSource_977001 =
      stateVars.GetItemInventoryWareHouseChar ??
      this.state.GetItemInventoryWareHouseChar;

    stateVars.dataSource_38920 =
      stateVars.GetItemInventoryGrid ?? this.state.GetItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UrunMaliyetAnaliziComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunMaliyetAnalizi",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "526188",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunMaliyetAnaliziComponent_19075_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunMaliyetAnalizi",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunMaliyetAnaliziComponent_98105_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunMaliyetAnaliziComponent_178454_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunmaliyetanalizi_636739_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      Filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunMaliyetAnalizi/UrunMaliyetAnaliziComponent_178454_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryGrid = result?.data.getItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunMaliyetAnaliziComponent_178454_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunMaliyetAnaliziComponent_178454_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.GetItemInventoryGrid ?? this.state.GetItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunMaliyetAnaliziComponent_530330_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      Filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunMaliyetAnalizi/UrunMaliyetAnaliziComponent_530330_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryGrid = result?.data.getItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunMaliyetAnaliziComponent_530330_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunMaliyetAnaliziComponent_530330_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunmaliyetanalizi_636739_value",
        "string"
      ),
      "",
      null,
      false
    );

    stateVars.dataSource_38920 =
      stateVars.GetItemInventoryGrid ?? this.state.GetItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [526188] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UrunMaliyetAnaliziPageInit();
    }
  }
}
